<template>
  <div ref="wrapper" :class="$style['product-sizes-stack']">
    <span
      v-for="(size, index) in filteredSizes"
      :key="size.size">{{ size.size }}
      <span
        v-if="index < filteredSizes.length - 1"
        :class="$style['product-sizes-stack__separator']">
        -
      </span>
    </span>
    <span
      v-if="filteredSizes.length < inStockSizes.length"
      :class="$style['product-sizes-stack__more']">
      +{{ inStockSizes.length - filteredSizes.length }}
    </span>
  </div>
</template>
<script setup>

const maxStringLength = ref(18)
const wrapper = ref(null)

const props = defineProps({
  sizes: {
    type: [Object, Array],
    default: null
  }
})

const filteredSizes = computed(() => {
  if (!props.sizes) { return [] }
  return inStockSizes.value.filter((size, index) => {
    return size.size.length + index * 3 < maxStringLength.value
  })
})
const inStockSizes = computed(() => {
  if (!props.sizes || !props.sizes[0]) { return [] }
  if (props.sizes[0].hasOwnProperty('stock')) {
    return props.sizes.filter(size => {
      return size.stock > 0
    })
  } else {
    return props.sizes
  }
})

onMounted(() => {
  if (wrapper.value.clientWidth < wrapper.value.scrollWidth) {
    maxStringLength.value = 12
  }
})
</script>
<style lang="scss" module>
.product-sizes-stack {
  align-items: center;
  justify-content: center;
  color: var(--grey-dark);
  display: inline-flex;
  overflow: hidden;
  font-size: var(--font-size-xxs);

  &__more {
    align-items: center;
    justify-content: center;
    border: 1px solid var(--grey-lighter);
    border-radius: 999px;
    display: inline-flex;
    color: var(--grey);
    margin-left: var(--spacing);
    font-size: var(--font-size-xxxs);
    font-weight: var(--font-weight-bold);
    width: calc(var(--spacing) * 2.5);
    height: calc(var(--spacing) * 2.5);
  }

  &__separator {
    margin-inline: 1px 4px;
  }
}
</style>
